import { TrashCan } from '@carbon/icons-react';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const MenuItem = styled(Menu.Item)`
  span {
    flex: 1;
  }
`;

export const Delete: FC<React.PropsWithChildren<MenuItemProps>> = (params) => {
  const { danger = true, icon = <TrashCan size={16} />, children } = params;

  return (
    <MenuItem danger={danger} icon={icon} {...params}>
      {children || <FormattedMessage id="delete" />}
    </MenuItem>
  );
};
